<template>
  <div class="mt-5 vs-con-loading__container" id="div-appointment-edit">

      <vs-collapse>
        <vs-collapse-item>
          <div slot="header">
            Dados do Paciente
          </div>
          <vx-card>
            <AppointmentInfo
              v-bind:idAppointment="this.data.idAppointment" />
          </vx-card>
        </vs-collapse-item>
      </vs-collapse>
      
        <vs-collapse>
          <vs-collapse-item>
            <div slot="header">
              Prontuário
            </div>
            <vx-card style="height:200px">
              <v-select
                label="scheduleDate"
                :options="this.data.historicAppointments"
                v-model="idHistoricAppointment"
              />
            </vx-card>
          </vs-collapse-item>
        </vs-collapse>

    <vs-tabs position="bottom">
      <vs-tab label="Acompanhantes">
        <vx-card>
          <AppointmentCompanion />
        </vx-card>
      </vs-tab>

      <vs-tab label="Queixas atuais" @click="changeForm('form-dietary-habits')">
        <vx-card>
          <AppointmentDetail 
            v-bind:idAppointment="this.data.idAppointment" />
        </vx-card>
      </vs-tab>

      <vs-tab label="Habitos Alimentares">
        <vs-collapse>
          <vs-collapse-item>
            <div slot="header">
              Histórico
            </div>
            <vx-card>
              <AppointmentDietaryHabits
                v-bind:idAppointment="this.data.idAppointment"
                v-bind:isReadOnly="true"
                :key="this.data.componentKey"
              />
            </vx-card>
          </vs-collapse-item>
        </vs-collapse>

        <vx-card>
          <AppointmentDietaryHabits 
            v-bind:idAppointment="this.data.idAppointment"/>
        </vx-card>
      </vs-tab>

      <vs-tab label="Outras informações">
        <vx-card>
          <AppointmentOtherInfos
            v-bind:idAppointment="this.data.idAppointment"
            v-bind:idPatient="this.data.idPatient"
          />
        </vx-card>
      </vs-tab>

      <vs-tab label="Avaliação Antropométrica">
        <vx-card>
          <AnthropometricEvaluation
            v-bind:idAppointment="this.data.idAppointment"
            v-bind:idPatient="this.data.idPatient"
          />
        </vx-card>
      </vs-tab>

      <vs-tab label="Diagnóstico Alimentar">
        <vx-card>
          <DietaryDiagnosticForm
            v-bind:idAppointment="this.data.idAppointment"
            v-bind:idPatient="this.data.idPatient"
          />
        </vx-card>
      </vs-tab>

      <vs-tab label="Conduta">
        <vx-card>
          <AppointmentMedicalConduct/>
        </vx-card>
      </vs-tab>
    </vs-tabs>

    <vs-button color="dark" @click="complete" type="border" icon-pack="feather" icon="icon-check-circle">Finalizar atendimento</vs-button>
  </div>
</template>

 <script>
// Components
import AppointmentDietaryHabits from "../../../views/sdn/appointment/AppointmentDietaryHabits";
import AppointmentCompanion from "../../../views/sdn/appointment/AppointmentCompanion";
import AppointmentOtherInfos from "../../../views/sdn/appointment/AppointmentOtherInfos";
import AnthropometricEvaluation from "../../../views/sdn/appointment/AnthropometricEvaluation";
import DietaryDiagnosticForm from "../../../views/sdn/appointment/dietaryDiagnostic/DietaryDiagnosticForm";
import AppointmentInfo from "../../../views/sdn/appointment/AppointmentInfo";
import AppointmentDetail from "../../../views/sdn/appointment/AppointmentDetail";
import AppointmentMedicalConduct from "../../../views/sdn/appointment/AppointmentMedicalConduct";
import vSelect from 'vue-select'

// Services
import AppointmentService from "../../../services/AppointmentService";

export default {
  components: {
    AppointmentDietaryHabits,
    AppointmentCompanion,
    AppointmentOtherInfos,
    AnthropometricEvaluation,
    DietaryDiagnosticForm,
    AppointmentInfo,
    AppointmentDetail,
    AppointmentMedicalConduct,
    vSelect
  },
  data() {
    return {
      data: {
        appointment: null,
        idAppointment: 0,
        idPatient: 0,
        form: "",
        historicAppointments: [],
        historicAppointment: null,
        componentKey: 0,
      },
      notifications: {
        notify: this.$vs.notify,
        dialog: this.$vs.dialog,
        errors: this.errors,
        showSucces: false,
        showError: false
      },
      defaultDivId: "div-appointment-edit",
      idHistoricAppointment: 0,
    };
  },
  created() {
    this.data.idAppointment = this.$route.params.id;
  },
  mounted: function() {
    this.get();
  },
  methods: {
    async get() {
      this.openLoadingInDiv(this.defaultDivId);

      const payload = {
        data: {
          idAppointment: this.data.idAppointment
        },
        notifications: this.notifications
      };

      payload.notifications.showSucces = false;
      payload.notifications.showError = false;

      var result = await AppointmentService.get(payload);

      if (result.status == 200) {
        if (result.data.result != null) {
          this.data.appointment = result.data.result;
          this.data.idPatient = result.data.result.idPatient;
          await this.getHistoricAppointments(this.data.idPatient, this.data.appointment.ScheduleDate);
        }
      }

      this.closeLoadingDiv(this.defaultDivId);
    },
    async complete() {
      this.openLoadingInDiv(this.defaultDivId);

      const payload = {
        data: {
          idAppointment: this.data.idAppointment
        },
        notifications: this.notifications
      };

      payload.notifications.showSucces = true;
      payload.notifications.showError = true;

      var result = await AppointmentService.complete(payload);

      if (result.status == 200) {
        if (result.data.result != null) {
          this.data.appointment = result.data.result;
          this.data.idPatient = result.data.result.idPatient;
        }
      }
      this.closeLoadingDiv(this.defaultDivId);
    },
    async getHistoricAppointments(idPatient) {
      const payload = {
        data: {
          idPatient: idPatient
        },
        notifications: this.notifications
      };

      payload.notifications.showSucces = false;
      payload.notifications.showError = false;

      var result = await AppointmentService.search(payload);

      if (result.status == 200) {
        if (result.data != null && result.data != undefined) {
          this.data.historicAppointments = result.data.filter(this.filterAppointment);
          console.log(this.data.historicAppointments);
        }
      }
    },
    historicAppointmentChange() {
      console.log("idHistoricAppointment");
      console.log(this.idHistoricAppointment.id);
       this.forceRerender();
    },
    filterAppointment(appointment) {
      return appointment.id != this.data.idAppointment;
    },
    forceRerender() {
      console.log("passou2");
      console.log("passou2");
      console.log(this.data);
      this.data.componentKey += 1;
    },
    changeForm(idForm) {
      this.form = idForm;
    },
    openLoadingInDiv(divId) {
      this.$vs.loading({
        container: "#" + divId,
        scale: 0.6
      });
    },
    closeLoadingDiv(divId) {
      this.$vs.loading.close("#" + divId + " > .con-vs-loading");
    }
  },
  watch: {
    idHistoricAppointment : function() {
      this.historicAppointmentChange();
    },
  }
};
</script>